import {isFulfilled, isRejected, Middleware} from "@reduxjs/toolkit";
import {API_SUCCESS, API_TIMEOUT} from "../types";

export const unauthorizedMiddleware: Middleware =
    (api) => (next) => (action) => {
        if (isFulfilled(action)) {
            if (document) {
                document.dispatchEvent(
                    // @ts-ignore
                    new CustomEvent(API_SUCCESS, {detail: {success: true}})
                );
            }
            //@ts-ignore
        } else if (isRejected(action) && action.payload?.status === 401) {
            if (document) {
                document.dispatchEvent(
                    // @ts-ignore
                    new CustomEvent(API_TIMEOUT)
                );
            }
        }

        return next(action);
    };
